module.exports = __webpack_public_path__ + "img/bread-pivot.67101533.png";